import "@aws-amplify/ui-react/styles.css";
import React from "react";
import NotFound from "./NotFound";
import { LoadingBlock } from "../controls/LoadingBlock";
import { AnnotateImage } from "../controls/AnnotateImage";
import { getDescriptor } from "../clients/photo-upload-client";
import { ImageDescriptorData } from "../clients/data-service";
import { Divider } from "@chakra-ui/react";
import NavButton from "../controls/NavButton";

class AnnotateImagePage extends React.Component<{}, {liveDescriptor?: ImageDescriptorData}> {

    imageId : string;
    constructor(props) {
        super(props);
        this.state = {
        };
        
        this.LoadData = this.LoadData.bind(this);

        const location = window.location;
        const paths = location.pathname.split('/');
        this.imageId = paths[paths.length - 1];

        
        this.LoadData();
    }

    async LoadData() : Promise<void> {
        const liveImageDesc = await getDescriptor(this.imageId);
        // this.setState(prev => {
        //     const newState = structuredClone(prev);
        //     newState.liveDescriptor = liveImageDesc;
        //     return newState;
        // });
        this.setState({ liveDescriptor: liveImageDesc });
    }

    componentDidMount() {
        
    }
    render() {
        if (this.state.liveDescriptor == null) {
            return <LoadingBlock />;
        }

        if (this.state.liveDescriptor.id == null) {
            return <NotFound message="Image Not Found" />;
        }
        return (
            <>
            <AnnotateImage imageDescriptor={this.state.liveDescriptor} refreshTrigger={this.LoadData} />
            <Divider />
            <NavButton to={`/delete-image/${this.imageId}`} text="Delete Image & Team Results" colorScheme="red"></NavButton></>
        );
    }
}

export default AnnotateImagePage;